import React from 'react';
import {AILabel} from './AILabel/AISearchBlock';
import cx from 'classnames';
import styles from './styles.module.scss';

export const AIButton = (props: {onClick: () => void; text: string; size?: 'small' | 'medium'}) => {
    const {onClick, text, size = 'medium'} = props;

    return (
        <button
            className={cx(styles.aiSearchButton, {
                [styles.medium]: size === 'medium',
                [styles.small]: size === 'small'
            })}
            onClick={onClick}
        >
            <AILabel text={text} />
        </button>
    );
};
